
<div class="estimate-details-main-page">
  <div class="container">
  <div class="grid">
    <!-- LEFT COLUMN -->
    <div class="left-col">
      <h1>Service Details</h1>
      <div class="service-header">
        <!-- <div class="svc-image">Service Image</div> -->
        <img src="../../../assets/img/estimate-image.jpg">
        <div class="svc-info">
          <h1>{{ serviceDetail.serviceKitDefinition.heading ?? 'Unknown' }}</h1>
          <div>
          <p class="meta">{{ serviceDetail.serviceKitDefinition.description ?? 'Details not available' }}</p>
            <!-- <div class="time-tag"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 5.83333V8.5L10 10.5M14 8.5C14 9.28793 13.8448 10.0681 13.5433 10.7961C13.2417 11.5241 12.7998 12.1855 12.2426 12.7426C11.6855 13.2998 11.0241 13.7417 10.2961 14.0433C9.56815 14.3448 8.78793 14.5 8 14.5C7.21207 14.5 6.43185 14.3448 5.7039 14.0433C4.97595 13.7417 4.31451 13.2998 3.75736 12.7426C3.20021 12.1855 2.75825 11.5241 2.45672 10.7961C2.15519 10.0681 2 9.28793 2 8.5C2 6.9087 2.63214 5.38258 3.75736 4.25736C4.88258 3.13214 6.4087 2.5 8 2.5C9.5913 2.5 11.1174 3.13214 12.2426 4.25736C13.3679 5.38258 14 6.9087 14 8.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Delivered in same day</div> -->
             <div class="time-tag" *ngIf="serviceDetail.parts.length && serviceDetail.parts[0]?.deliveryTime">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5.83333V8.5L10 10.5M14 8.5C14 9.28793 13.8448 10.0681 13.5433 10.7961C13.2417 11.5241 12.7998 12.1855 12.2426 12.7426C11.6855 13.2998 11.0241 13.7417 10.2961 14.0433C9.56815 14.3448 8.78793 14.5 8 14.5C7.21207 14.5 6.43185 14.3448 5.7039 14.0433C4.97595 13.7417 4.31451 13.2998 3.75736 12.7426C3.20021 12.1855 2.75825 11.5241 2.45672 10.7961C2.15519 10.0681 2 9.28793 2 8.5C2 6.9087 2.63214 5.38258 3.75736 4.25736C4.88258 3.13214 6.4087 2.5 8 2.5C9.5913 2.5 11.1174 3.13214 12.2426 4.25736C13.3679 5.38258 14 6.9087 14 8.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ serviceDetail.parts[0].deliveryTime }}
            </div>

          </div>
          <div class="tags">
            <div class="tag assured"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8.5L7.33333 9.83333L10 7.16667M14 8.5C14 9.28793 13.8448 10.0681 13.5433 10.7961C13.2417 11.5241 12.7998 12.1855 12.2426 12.7426C11.6855 13.2998 11.0241 13.7417 10.2961 14.0433C9.56815 14.3448 8.78793 14.5 8 14.5C7.21207 14.5 6.43185 14.3448 5.7039 14.0433C4.97595 13.7417 4.31451 13.2998 3.75736 12.7426C3.20021 12.1855 2.75825 11.5241 2.45672 10.7961C2.15519 10.0681 2 9.28793 2 8.5C2 6.9087 2.63214 5.38258 3.75736 4.25736C4.88258 3.13214 6.4087 2.5 8 2.5C9.5913 2.5 11.1174 3.13214 12.2426 4.25736C13.3679 5.38258 14 6.9087 14 8.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Autoverse Assured</div>
            <div class="tag genuine"><svg width="16" height="16" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.66667 7.16667V2.5L2.66667 9.83333H7.33334V14.5L13.3333 7.16667H8.66667Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Genuine Parts</div>
            
            <div class="tag warranty"><svg width="16" height="16" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8.50001L7.33334 9.83334L10 7.16668M13.7453 4.48934C11.6374 4.60129 9.57116 3.87242 8 2.46268C6.42885 3.87242 4.3626 4.60129 2.25467 4.48934C2.08502 5.14609 1.99945 5.82171 2 6.50001C2 10.2273 4.54934 13.36 8 14.248C11.4507 13.36 14 10.228 14 6.50001C14 5.80534 13.9113 5.13201 13.7453 4.48934Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Warranty Support</div>
          </div>
        </div>
      </div>
      <!-- What's included -->
      <div class="section">
        <h3>What’s included</h3>
        <ul class="checklist">
          <li *ngFor="let item of serviceDetail.whatsIncluded">
            {{ item }}
          </li>
          <li *ngIf="serviceDetail.whatsIncluded.length === 0">No items available.</li>
        </ul>
      </div>
      <!-- FAQs -->
      <div class="card-faq-main">
        <h3>Frequently Asked Questions</h3>
        <div class="card faq">
          <details *ngFor="let faq of serviceDetail.faqs">
            <summary>{{ faq.question }}
              <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.6666 1.5L5.99998 6.16667L1.33331 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </summary>
            <p>{{ faq.answer }}</p>
          </details>
          <div *ngIf="serviceDetail.faqs.length === 0">No FAQs available.</div>
        </div>
      </div>
    </div>

    <!-- RIGHT COLUMN -->
    <div class="right-col">
      <!-- Parts Breakdown -->
      <div class="card">
        <h3>Parts Breakdown</h3>
        <table class="parts-table">
          <thead style="background: white !important;">
            <tr>
              <th>PART</th>
              <th>BRAND</th>
              <th class="text-right">MRP (Unit)</th>
              <th class="text-right">Qty</th>
              <th class="text-right">MRP (Total)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let part of serviceDetail.parts">
              <td>{{ part.partName || 'Pending' }}</td>
              <td>{{ part.brandName || 'Pending' }}</td>
              <td class="text-right">
                <span *ngIf="part.zohoPartPrice !== null; else pendingPrice">₹{{ part.zohoPartPrice }}</span>
                <ng-template #pendingPrice><span class="pending-tag">Pending</span></ng-template>
              </td>
              <td class="text-right"><span class="pending-tag-qty">{{ part.quantity }}</span></td>
              <td class="text-right">
                <span *ngIf="part.zohoPartPrice !== null; else pendingTotal">₹{{ part.zohoPartPrice }}</span>
                <ng-template #pendingTotal><span class="pending-tag">Pending</span></ng-template>
              </td>
            </tr>

            <tr *ngIf="serviceDetail.parts.length === 0">
              <td colspan="5">No parts available.</td>
            </tr>
          </tbody>
        </table>

        <!-- Parts Subtotal -->
        <div class="summary-row total">
          <span>Parts Subtotal:</span>
          <span class="amount">
            ₹{{ partsSubtotal }}
            <ng-container *ngIf="hasPendingParts">
              <span class="pending-text">+ pending</span>
              <span 
                class="info-icon"
                (click)="showPendingInfo = !showPendingInfo"
              >?</span>

              <!-- Message Box -->
              <div class="pending-info" *ngIf="showPendingInfo">
                Awaiting price for 
                <span *ngFor="let part of pendingPartNames; let i = index">
                  {{ part }}<span *ngIf="i < pendingPartNames.length - 1">, </span>
                </span>
              </div>
            </ng-container>
          </span>
        </div>
      </div>


      <!-- Labour Breakdown -->
      <div class="card">
        <h3>Labour Breakdown</h3>
        <div *ngFor="let labour of serviceDetail.labours" class="summary-row">
          <span>{{ labour.labourName || 'Pending' }}</span>
          <span>
            <ng-container *ngIf="labour.labourRate !== null; else pendingLabour">
              ₹{{ labour.labourRate }}
            </ng-container>
            <ng-template #pendingLabour><span class="pending-tag">Pending</span></ng-template>
          </span>
        </div>

        <!-- Labour Subtotal -->
        <div class="summary-row total">
          <span>Labour Subtotal:</span>
          <span *ngIf="labourSubtotal !== null; else pendingLabourTotal">₹{{ labourSubtotal }}</span>
          <ng-template #pendingLabourTotal><span class="pending-tag">Pending</span></ng-template>
        </div>
      </div>

      <!-- Cost Summary -->
      <div class="cost-summary">
        <h3>Cost Summary</h3>

        <div class="summary-row">
          <span class="label">Parts Subtotal</span>
          <span class="value pending">₹{{ partsSubtotal }}</span>
        </div>

        <div class="summary-row">
          <span class="label">Labour Subtotal</span>
          <span class="value">₹{{ labourSubtotal || 0 }}</span>
        </div>

        <!-- <div class="summary-row">
          <span class="label">Taxes ({{ labourGstRate ? labourGstRate + '%' : 'N/A' }} GST)</span>
          <span class="value pending">{{ labourGstRate ? labourGstRate + '%' : 'Pending' }}</span>
        </div> -->

        <!-- Estimated Total Box -->
        <div class="estimated-box">
          <span class="estimate-text">Estimated Total</span>
          <ng-container *ngIf="!hasPendingParts; else pendingTotal">
            <span class="estimated-amount">₹{{ grandTotal }}</span>
          </ng-container>
          <ng-template #pendingTotal>
            <span class="estimated-amount">Will be shared post inspection</span>
          </ng-template>
        </div>

        <!-- Note -->
        <p class="note">
          *This is an estimate. Final price will be confirmed after inspection. You'll be notified before billing.
        </p>
      </div>


    </div>


  </div>

  <!-- Bottom Actions -->
  <div class="actions">
    <!-- <button class="btn save"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.33333 4.66663H3.33333C2.97971 4.66663 2.64057 4.8071 2.39052 5.05715C2.14048 5.3072 2 5.64634 2 5.99996V12C2 12.3536 2.14048 12.6927 2.39052 12.9428C2.64057 13.1928 2.97971 13.3333 3.33333 13.3333H12.6667C13.0203 13.3333 13.3594 13.1928 13.6095 12.9428C13.8595 12.6927 14 12.3536 14 12V5.99996C14 5.64634 13.8595 5.3072 13.6095 5.05715C13.3594 4.8071 13.0203 4.66663 12.6667 4.66663H10.6667M10 7.33329L8 5.33329M8 5.33329L6 7.33329M8 5.33329V13.3333" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Save Estimate
    </button> -->
    <button class="btn primary"  data-bs-toggle="modal" data-bs-target="#requestCallBackModal">
      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.66667 5.66667V9.66667M5.66667 9.66667L3.66667 7.66667M5.66667 9.66667L7.66667 7.66667M9 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V2.33333C1 1.97971 1.14048 1.64057 1.39052 1.39052C1.64057 1.14048 1.97971 1 2.33333 1H6.05733C6.23413 1.00004 6.40367 1.0703 6.52867 1.19533L10.138 4.80467C10.263 4.92966 10.3333 5.0992 10.3333 5.276V11.6667C10.3333 12.0203 10.1929 12.3594 9.94281 12.6095C9.69276 12.8595 9.35362 13 9 13Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Download PDF
    </button>
    
  </div>
</div>

</div>

 <!-- ==========requesta-a-call-bac-pop-up======= -->
  <div class="modal fade" id="requestCallBackModal" tabindex="-1" aria-labelledby="requestCallBackModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg custom-modal">
        <div class="modal-content" style="border-radius: 16px; padding: 10px;">

        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center mb-3" style=" padding: 10px 20px; margin: 0 !important; background: linear-gradient(to right, #F7FBFF, #FFFFFF);     border-radius: 10px;">
            <h3 class="fw-bold m-0" style="font-size: 20px; font-weight: 900 !important; color: #0B2636;">
            <div class="call-icon-and-text">
                <img src="./assets/img/call-image.png">
                <div> Customer Details </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            
            </h3>
            
        </div>

        <p class="text-muted mb-4" style=" font-size: 14px !important;color: #57738A !important; padding: 5px 20px; margin: 0 !important; font-weight: 400;">Leave your details to book a service.</p>

        <!-- Form -->
        <form [formGroup]="callbackForm" (ngSubmit)="submitForm()" style="padding: 10px 20px;">
        <input type="text" formControlName="name" class="form-control mb-2 p-2" placeholder="Name*" required>
        <input type="text" formControlName="mobile" class="form-control mb-2 p-2" placeholder="Mobile Number*" maxlength="10" required>
        <!-- <input type="text" formControlName="issue" class="form-control mb-2 p-2" placeholder="Describe Your Issue (Optional)"> -->

        <!-- Coupons Section -->
        <!-- <div *ngIf="coupons.length > 0" class="coupon-options mb-4">
            <div *ngFor="let c of coupons" 
                class="coupon-card-option"
                [class.active]="selectedCoupon?.couponId === c.couponId"
                (click)="applyCoupon(c)">
            <h5 class="fw-bold mb-1">{{ c.couponCode }} - {{ c.discount }}%</h5>
            <p class="small m-0 text-muted">{{ c.description }}</p>
            </div>
        </div> -->

        <!-- <button type="submit" class="submit-btn btn-primary w-100 p-3 fw-bold">
            Submit Details
        </button> -->
          <button type="submit" class="btn btn-primary w-100" style="  background: #144579;">Submit Details</button>
        
        </form>
        </div>
    </div>
</div>



<app-loading *ngIf="loading"></app-loading>